<template>
  <div>
    <button
      type="button"
      @click="imageLibraryModalClick"
      :disabled="buttonDisabled"
      class="flex justify-between"
    >
      <library-icon></library-icon>
      <span class="text-12 ml-2">{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>
import LibraryIcon from "@/assets/library-icon.svg";
export default {
  name: "CertLibraryButton",
  props: {
    uploadType: String,
    buttonText: String,
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    imageLibraryModalClick(e) {
      // this.$emit("click", { e });
      if (this.uploadType !== undefined) {
        this.$emit("click", {
          length: this.maxLength,
          param: this.uploadType,
          e,
        });
      } else {
        this.$emit("click", { e });
      }
    },
  },
  components: {
    LibraryIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/tailwind.scss";
button {
  padding: 8px 16px;
  border: 1px solid $borderLightGray;
  border-radius: $exMtmBtnBorderRadius;
  background-color: #fff;
  color: $exBlack;
  font-weight: bold;
  line-height: 17px;
  cursor: pointer;
  min-width: 92px;
}

button:disabled {
  cursor: default;
}

button:not(:disabled):hover,
button:not(:disabled):focus {
  border-color: $exMtm;
  color: $exMtm;
}
</style>
